import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { clearTokens, getToken } from "../services/tokenService";
import toast from "react-hot-toast";

const AutoLogout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let timeout;

    const logout = () => {
      if (!getToken()) return;

      clearTokens();

      toast.error("Session expired. Please login again.");

      navigate("/");
    };

    const resetTimer = () => {
      clearTimeout(timeout);

      timeout = setTimeout(logout, 15 * 60 * 1000);
    };

    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("click", resetTimer);
    window.addEventListener("scroll", resetTimer);

    resetTimer();

    return () => {
      clearTimeout(timeout);

      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
      window.removeEventListener("scroll", resetTimer);
    };
  }, [navigate]);

  return null;
};

export default AutoLogout;